import React, {Component} from 'react';
import {Row, Col, Collapse, Alert} from 'antd';
import DeviceAIN from './DeviceAIN'
import DeviceDIN from './DeviceDIN'
import DeviceRelay from './DeviceRelay'
import IconTemperature from '../style/icon/IconTemperature'
import IconHumidity from '../style/icon/IconHumidity'
import IconDoorOpened from '../style/icon/IconDoorOpened'
import IconDoorClosed from '../style/icon/IconDoorClosed'
import IconMotion from '../style/icon/IconMotion'
import IconSmoke from '../style/icon/IconSmoke'
import IconFire from '../style/icon/IconFire'
import IconLamp from '../style/icon/IconLamp'
import IconLampChandelier from '../style/icon/IconLampChandelier'
import IconLampCeilling from '../style/icon/IconLampCeilling'
import IconLampCompact from '../style/icon/IconLampCompact'
import IconLampSleep from '../style/icon/IconLampSleep'
import IconLampDecor from '../style/icon/IconLampDecor'
import IconFan1 from '../style/icon/IconFan1'
import IconFan2 from '../style/icon/IconFan2'
import IconFanCeilling from '../style/icon/IconFanCeilling'
import IconHeater from '../style/icon/IconHeater'
import IconPump from '../style/icon/IconPump'
import IconAirController from '../style/icon/IconAirController'
import IconACMeter from '../style/icon/IconACMeter'
import IconPowerDayMeter from '../style/icon/IconPowerDayMeter'
import IconPowerMonthMeter from '../style/icon/IconPowerMonthMeter'
import IconPowerCurrentMeter from '../style/icon/IconPowerCurrentMeter'
import IconPowerMeter from '../style/icon/IconPowerMeter'
import IconShine from '../style/icon/IconShine'
import IconCurtainOpened from '../style/icon/IconCurtainOpened'
import IconCurtainClosed from '../style/icon/IconCurtainClosed'
import IconSiren from '../style/icon/IconSiren'

import {
  SUB_CATEGORY_TEMPERATURE,
  SUB_CATEGORY_HUMIDITY,
  SUB_CATEGORY_V_AC_METER,
  SUB_CATEGORY_SMOKE,
  SUB_CATEGORY_DOOR,
  SUB_CATEGORY_MOTION,
  SUB_CATEGORY_LUMINARY,
  //SUB_CATEGORY_GLASS,
  //SUB_CATEGORY_GAS,
  SUB_CATEGORY_HEAT_EXCEED,
  //SUB_CATEGORY_BUTTON,
  SUB_CATEGORY_LAMP,
  SUB_CATEGORY_LAMP_COMPACT,
  SUB_CATEGORY_LAMP_SLEEP,
  SUB_CATEGORY_LAMP_TABLE,
  SUB_CATEGORY_LAMP_CEILLING,
  SUB_CATEGORY_LAMP_DECOR,
  SUB_CATEGORY_LAMP_CHANDELIER,
  SUB_CATEGORY_FAN_1,
  SUB_CATEGORY_FAN_2,
  SUB_CATEGORY_FAN_CEILLING,
  SUB_CATEGORY_OUTLET,
  SUB_CATEGORY_WATERING,
  SUB_CATEGORY_HEATER,
  SUB_CATEGORY_BELL,
  SUB_CATEGORY_ALARM_BELL,
  SUB_CATEGORY_DO_NOT_DISTURB,
  SUB_CATEGORY_CURTAIN,
  SUB_CATEGORY_AIR_CONTROLLER,
  SUB_CATEGORY_PUMP,
  SUB_CATEGORY_DOOR_IN_HOUSE,
  SUB_CATEGORY_TEMPERATURE_OUTSIDE,
  SUB_CATEGORY_HUMIDITY_OUTSIDE,
  SUB_CATEGORY_POWER_METER,
  SUB_CATEGORY_POWER_METER_DAY,
  SUB_CATEGORY_POWER_METER_MONTH,
  SUB_CATEGORY_POWER_METER_COUNTER,
  DEVICE_STATUS_STATE_ON
} from '../constants/defaultValues'
const PanelCollapse = Collapse.Panel;

class StationCardDevice extends Component {
  handleRelayClick(dev) {
    this.props.onRelayClick(dev)
  }

  handleAINClick(dev) {
    this.props.onAINClick(dev)
  }

  handleDINClick(dev) {
    this.props.onDINClick(dev)
  }

  displayDevice(dev) {
    switch (dev.SubCategory) {
      case SUB_CATEGORY_TEMPERATURE:
      case SUB_CATEGORY_TEMPERATURE_OUTSIDE:
        return <DeviceAIN icon={<IconTemperature color = {
            dev.Color
          } />} device={dev} onClick={(dev) => this.handleAINClick(dev)}/>
      case SUB_CATEGORY_HUMIDITY:
      case SUB_CATEGORY_HUMIDITY_OUTSIDE:
        return <DeviceAIN icon={<IconHumidity color = {
            dev.Color
          } />} device={dev} onClick={(dev) => this.handleAINClick(dev)}/>
      case SUB_CATEGORY_V_AC_METER:
        return <DeviceAIN icon={<IconACMeter color = {
            dev.Color
          } />} device={dev} onClick={(dev) => this.handleAINClick(dev)}/>
      case SUB_CATEGORY_POWER_METER_COUNTER:
        return <DeviceAIN icon={<IconPowerMeter color = {
            dev.Color
          } />} device={dev} onClick={(dev) => this.handleAINClick(dev)}/>
      case SUB_CATEGORY_POWER_METER:
        return <DeviceAIN icon={<IconPowerCurrentMeter color = {
            dev.Color
          } />} device={dev} onClick={(dev) => this.handleAINClick(dev)}/>
      case SUB_CATEGORY_POWER_METER_DAY:
        return <DeviceAIN icon={<IconPowerDayMeter color = {
            dev.Color
          } />} device={dev} onClick={(dev) => this.handleAINClick(dev)}/>
      case SUB_CATEGORY_POWER_METER_MONTH:
        return <DeviceAIN icon={<IconPowerMonthMeter color = {
            dev.Color
          } />} device={dev} onClick={(dev) => this.handleAINClick(dev)}/>
      case SUB_CATEGORY_LUMINARY:
        return <DeviceAIN icon={<IconShine color = {
            dev.Color
          } />} device={dev} onClick={(dev) => this.handleAINClick(dev)}/>
      case SUB_CATEGORY_SMOKE:
        return <DeviceDIN icon={<IconSmoke color = {
            dev.Color
          } />} device={dev} onClick={(dev) => this.handleDINClick(dev)}/>
      case SUB_CATEGORY_HEAT_EXCEED:
        return <DeviceDIN icon={<IconFire color = {
            dev.Color
          } />} device={dev} onClick={(dev) => this.handleDINClick(dev)}/>
      case SUB_CATEGORY_DOOR:
      case SUB_CATEGORY_DOOR_IN_HOUSE:
        if (dev.State === DEVICE_STATUS_STATE_ON) {
          return <DeviceDIN icon={<IconDoorOpened color = {
              dev.Color
            } />} device={dev} onClick={(dev) => this.handleDINClick(dev)}/>
        } else {
          return <DeviceDIN icon={<IconDoorClosed color = {
              dev.Color
            } />} device={dev} onClick={(dev) => this.handleDINClick(dev)}/>
        }
      case SUB_CATEGORY_MOTION:
        return <DeviceDIN icon={<IconMotion color = {
            dev.Color
          } />} device={dev} onClick={(dev) => this.handleDINClick(dev)}/>
      case SUB_CATEGORY_ALARM_BELL:
        return <DeviceRelay icon={<IconSiren color = {
            dev.Color
          } />} device={dev} onClick={(dev) => this.handleRelayClick(dev)}/>
      case SUB_CATEGORY_LAMP:
      case SUB_CATEGORY_LAMP_TABLE:
      case SUB_CATEGORY_OUTLET:
      case SUB_CATEGORY_WATERING:
      case SUB_CATEGORY_BELL:

      case SUB_CATEGORY_DO_NOT_DISTURB:
        return <DeviceRelay icon={<IconLamp color = {
            dev.Color
          } />} device={dev} onClick={(dev) => this.handleRelayClick(dev)}/>
      case SUB_CATEGORY_FAN_1:
        return <DeviceRelay icon={<IconFan1 color = {
            dev.Color
          } />} device={dev} onClick={(dev) => this.handleRelayClick(dev)}/>
      case SUB_CATEGORY_FAN_2:
        return <DeviceRelay icon={<IconFan2 color = {
            dev.Color
          } />} device={dev} onClick={(dev) => this.handleRelayClick(dev)}/>
      case SUB_CATEGORY_FAN_CEILLING:
        return <DeviceRelay icon={<IconFanCeilling color = {
            dev.Color
          } />} device={dev} onClick={(dev) => this.handleRelayClick(dev)}/>
      case SUB_CATEGORY_LAMP_DECOR:
        return <DeviceRelay icon={<IconLampDecor color = {
            dev.Color
          } />} device={dev} onClick={(dev) => this.handleRelayClick(dev)}/>
      case SUB_CATEGORY_LAMP_CHANDELIER:
        return <DeviceRelay icon={<IconLampChandelier color = {
            dev.Color
          } />} device={dev} onClick={(dev) => this.handleRelayClick(dev)}/>
      case SUB_CATEGORY_LAMP_COMPACT:
        return <DeviceRelay icon={<IconLampCompact color = {
            dev.Color
          } />} device={dev} onClick={(dev) => this.handleRelayClick(dev)}/>
      case SUB_CATEGORY_LAMP_SLEEP:
        return <DeviceRelay icon={<IconLampSleep color = {
            dev.Color
          } />} device={dev} onClick={(dev) => this.handleRelayClick(dev)}/>
      case SUB_CATEGORY_LAMP_CEILLING:
        return <DeviceRelay icon={<IconLampCeilling color = {
            dev.Color
          } />} device={dev} onClick={(dev) => this.handleRelayClick(dev)}/>
      case SUB_CATEGORY_HEATER:
        return <DeviceRelay icon={<IconHeater color = {
            dev.Color
          } />} device={dev} onClick={(dev) => this.handleRelayClick(dev)}/>
      case SUB_CATEGORY_PUMP:
        return <DeviceRelay icon={<IconPump color = {
            dev.Color
          } />} device={dev} onClick={(dev) => this.handleRelayClick(dev)}/>
      case SUB_CATEGORY_AIR_CONTROLLER:
        return <DeviceRelay icon={<IconAirController color = {
            dev.Color
          } />} device={dev} onClick={(dev) => this.handleRelayClick(dev)}/>
      case SUB_CATEGORY_CURTAIN:
        if (dev.State === DEVICE_STATUS_STATE_ON) {
          return <DeviceRelay icon={<IconCurtainOpened color = {
              dev.Color
            } />} device={dev} onClick={(dev) => this.handleRelayClick(dev)}/>
        } else {

          return <DeviceRelay icon={<IconCurtainClosed color = {
              dev.Color
            } />} device={dev} onClick={(dev) => this.handleRelayClick(dev)}/>
        }
      default:
        return <span>{dev.Name}</span>
    }
  }

  render() {
    const small = this.props.small
    const col = small
      ? 8
      : 6
    const rooms = this.props.rooms || []
    const devices = this.props.devices || []
    const defaultActiveKey = ['room 0']
    return <div>
      {
        !this.props.error
          ? <div>{
                <Row align="middle" key='roomdefault'>
                    <ul className="icons-list">
                      {
                        devices.filter((dev) => {
                          return dev.RoomId === 0
                        }).map((dev) => {
                          const elementDev = this.displayDevice(dev)
                          return <Col xs={{
                              span: 12
                            }} sm={{
                              span: 8
                            }} md={{
                              span: 8
                            }} lg={{
                              span: col
                            }} xl={{
                              span: col
                            }} key={dev.DeviceId}>
                            <li>
                              {elementDev}
                            </li>
                          </Col>
                        })
                      }
                    </ul>
                  </Row>
              }<Collapse bordered={false} defaultActiveKey={defaultActiveKey}>
                {
                  rooms.map((room, i) => {
                    return <PanelCollapse header={room.Name} key={"room " + i.toString()}>
                      <Row align="middle" key={room.Name}>
                        <ul className="icons-list">
                          {
                            devices.filter((dev) => {
                              return dev.RoomId === room.RoomId
                            }).map((dev) => {
                              const elementDev = this.displayDevice(dev)
                              return <Col xs={{
                                  span: 8
                                }} sm={{
                                  span: 8
                                }} md={{
                                  span: 8
                                }} lg={{
                                  span: col
                                }} xl={{
                                  span: col
                                }} key={dev.DeviceId}>
                                <li>
                                  {elementDev}
                                </li>
                              </Col>
                            })
                          }
                        </ul>
                      </Row>
                    </PanelCollapse>
                  })
                }
              </Collapse>
            </div>
          : <Alert message="Error" description="Lỗi dữ liệu!" type="error"/>
      }
    </div>;
  }
}

export default StationCardDevice;



// WEBPACK FOOTER //
// ./src/components/StationCardDevice.js